import React from 'react';

/**
 * Prominent "Decommissioned" marker shown wherever a device is listed.
 * Renders nothing when the device is active, so call sites can drop it in
 * unconditionally.
 */
const DecommissionedBadge: React.FC<{ decommissioned?: boolean; className?: string }> = ({
  decommissioned,
  className = '',
}) => {
  if (!decommissioned) return null;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-sm border border-status-error-border bg-status-error px-1.5 py-0.5 text-xs font-semibold uppercase tracking-wide text-status-error-foreground ${className}`}
      title="This device is decommissioned"
    >
      Decommissioned
    </span>
  );
};

export default DecommissionedBadge;
